/**
 * Regex to check password
 * Per https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
 * Min 1 uppercase letter.
 * Min 1 number.
 * Min 9 characters.
 * Max 30 characters
 * @type {RegExp}
 */

const password = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&.,\-|+~#_/()[\]{}=]{9,30}$/

export default password
